import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';

import CommonButton from '../../../../../../components/common-button/CommonButton';
import Icon from '../../../../../../icons/Icon';
import { ICONS } from '../../../../../../icons';
import CommonTooltip from '../../../../../../components/common-tooltip/CommonTooltip';
import {
  addDataset,
  cancelProgress,
  crawlMissingDomains,
  deleteSelectedItems,
  editDataset,
  importDataset,
} from '../../../../../../redux/sonar-management/sonarManagementActions';
import SonarDatasetModal from '../../../sonar-dataset-modal/SonarDatasetModal';
import { CRAWL_PROJECT_STATUS, SONAR_PROGRESS_TYPE } from '../../../../../../constants';
import ImportDataset from '../../../sonar-creation-form/components/ImportDataset';
import CommonIconButton from '../../../../../../components/common-icon-button/CommonIconButton';

import scss from './CollectDataFilters.module.scss';

const CollectDataFilters = ({ disableTooltip, disableActionButtons, onEditDatasetEnd, selectedDataset }) => {
  const { t } = useTranslation('projects');
  const [isDatasetModalOpen, setIsDatasetModalOpen] = useState();
  const dispatch = useDispatch();
  const { id } = useParams();

  const crawlDataProgress = useSelector((state) => state.sonarManagement.sonarProgress[SONAR_PROGRESS_TYPE.CRAWL]);
  const collectDataProgress = useSelector(
    (state) => state.sonarManagement.sonarProgress[SONAR_PROGRESS_TYPE.COLLECT_SONAR],
  );

  const handleCrawlMissingSocials = () => {
    dispatch(crawlMissingDomains(id));
  };

  const handleOpenAddDatasetModal = () => {
    setIsDatasetModalOpen(true);
  };

  const handleCloseAddDatasetModal = () => {
    setIsDatasetModalOpen(false);
    onEditDatasetEnd();
  };

  const handleAddDataset = async (values) => {
    await dispatch(addDataset({ values, projectId: id }));
  };

  const handleEditDataset = async (values) => {
    await dispatch(editDataset({ values, datasetId: selectedDataset.id, projectId: id }));
    onEditDatasetEnd();
  };

  const handleImportDataset = (file) => {
    dispatch(importDataset({ file, id }));
  };

  const handleDeleteSelectedDataset = () => {
    dispatch(deleteSelectedItems());
  };

  const handleCancelCrawling = () => {
    dispatch(cancelProgress({ progressId: crawlDataProgress.id, jobEntityId: id }));
  };

  return (
    <div className={scss.wrapper}>
      <div className={scss.leftBlock}>
        {crawlDataProgress.status === CRAWL_PROJECT_STATUS.EXECUTING ? (
          <span className={scss.progress}>
            {t('progressOf', { from: crawlDataProgress.handled, to: crawlDataProgress.total })}
          </span>
        ) : null}

        <div className={scss.crawlSection}>
          {/* <span className={scss.errors}>
            {t('errors')}: <span>{crawlErrors}</span>
          </span> */}

          <CommonTooltip title={disableTooltip}>
            <span style={{ width: '140px' }}>
              <CommonButton
                type='button'
                styleColor='primary'
                maxWidth={140}
                onClick={handleCrawlMissingSocials}
                isLoading={
                  crawlDataProgress.status === CRAWL_PROJECT_STATUS.EXECUTING ||
                  crawlDataProgress.status === CRAWL_PROJECT_STATUS.EXECUTE
                }
                disabled={
                  collectDataProgress.status &&
                  (collectDataProgress.status === CRAWL_PROJECT_STATUS.EXECUTE ||
                    collectDataProgress.status === CRAWL_PROJECT_STATUS.EXECUTING)
                }>
                {t('crawlMissing')}
              </CommonButton>
            </span>
          </CommonTooltip>

          {crawlDataProgress.status === CRAWL_PROJECT_STATUS.EXECUTING ||
          crawlDataProgress.status === CRAWL_PROJECT_STATUS.EXECUTE ? (
            <CommonIconButton
              icon={ICONS.Cross}
              onClick={handleCancelCrawling}
              isStrokeIcon
              size='large'
              iconClassName={scss.cancelIcon}
              tooltip={t('cancelCrawling')}
            />
          ) : null}
        </div>
      </div>

      <div className={scss.rightBlock}>
        <CommonTooltip title={disableTooltip}>
          <span style={{ width: '140px' }}>
            <CommonButton
              type='button'
              styleColor='primary'
              maxWidth={140}
              onClick={handleOpenAddDatasetModal}
              disabled={disableActionButtons}>
              {t('addDataset')}
            </CommonButton>
          </span>
        </CommonTooltip>

        {/* <CommonButton type='button' styleColor='secondary' maxWidth={140} onClick={() => null} disabled>
          <Icon icon={ICONS.Edit} disableCommonColors />
          {t('edit')}
        </CommonButton>

        <CommonButton type='button' styleColor='secondary' maxWidth={140} onClick={() => null} disabled>
          <Icon icon={ICONS.Return} disableCommonColors />
          {t('return')}
        </CommonButton> */}

        <CommonTooltip title={disableTooltip}>
          <span style={{ width: '140px' }}>
            <ImportDataset disabled={disableActionButtons} onSubmit={handleImportDataset} />
          </span>
        </CommonTooltip>

        <CommonTooltip title={disableTooltip}>
          <span style={{ width: '140px' }}>
            <CommonButton
              type='button'
              styleColor='secondary'
              onClick={handleDeleteSelectedDataset}
              disabled={disableActionButtons}>
              <Icon icon={ICONS.Delete} disableCommonColors />
              {t('delete')}
            </CommonButton>
          </span>
        </CommonTooltip>
      </div>

      <SonarDatasetModal
        isOpen={isDatasetModalOpen || selectedDataset?.id}
        onClose={handleCloseAddDatasetModal}
        onAdd={handleAddDataset}
        onEdit={handleEditDataset}
        datasetId={selectedDataset?.id}
      />
    </div>
  );
};

export default CollectDataFilters;
